/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCUpIcon16Solid = forwardRef('ArrowCUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.622 10.89a1.25 1.25 0 0 1-.012-1.768L6.403 5.28a2.25 2.25 0 0 1 3.193-.01l3.788 3.788a1.25 1.25 0 0 1-1.768 1.767l-3.61-3.61-3.616 3.663a1.25 1.25 0 0 1-1.768.012Z" })));
});
